<app-attendee-layout>
  <h1 class="title-4 mb-4">{{ 'attendee.inbox.title' | translate }}</h1>

  <app-messaging-inbox
    *ngIf="!isLoading"
    [recipient]="recipient"
  ></app-messaging-inbox>
</app-attendee-layout>
